import { render, staticRenderFns } from "./SCardHeader.vue?vue&type=template&id=33a8d4ae&scoped=true&"
import script from "./SCardHeader.vue?vue&type=script&lang=js&"
export * from "./SCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./SCardHeader.vue?vue&type=style&index=0&id=33a8d4ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a8d4ae",
  null
  
)

export default component.exports